/* final-qa 2026-10-23 — the Order Limits app injects `table.order-limit-limits-table` into the PDP
   form with a hard-coded Arabic caption and English column headers, on every locale. Localise
   it in place (EN page: caption in English; AR page: headers in Arabic). Content-only, never
   touches the numbers. Safe no-op when the app table is absent. */
(function () {
  var ar = (window.CMConfig && window.CMConfig.locale) === 'ar' || document.documentElement.lang.indexOf('ar') === 0;
  var H = { minimum: 'الحد الأدنى', increments: 'المضاعفات' };
  function fix(t) {
    if (!t || t.getAttribute('data-cm-i18n')) return;
    var cap = t.querySelector('caption');
    if (cap) {
      var m = cap.textContent.match(/(\d+)/);
      var n = m ? m[1] : '';
      if (!ar && /[؀-ۿ]/.test(cap.textContent)) cap.textContent = n ? 'Order ' + n + ' pieces or multiples of ' + n + ' to get the offer' : 'Order the required multiples to get the offer';
      cap.style.textAlign = 'start';
    }
    if (ar) {
      t.querySelectorAll('th').forEach(function (th) {
        var k = th.textContent.trim().toLowerCase();
        if (H[k]) th.textContent = H[k];
      });
    }
    t.setAttribute('data-cm-i18n', '1');
  }
  function run() { document.querySelectorAll('table.order-limit-limits-table').forEach(fix); }
  run();
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { run(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
